module.exports = {
  version: "6.0.45"
};

